import angular from "angular"

// NOTE: 매장 설정 폼에서 선택 가능한 산업 코드 목록. 신규 업종 추가 시 여기에 코드를 추가해야 한다.
export const rtIndustryCode = [
  "G21101", // 가구 소매업 > 가구 소매업
  "G20911", // 섬유, 의복, 신발 및 가죽제품 소매업 > 가방 소매업
  "G20803", // 가전제품 및 정보 통신장비 소매업 > 가전제품 소매업
  "G20905", // 섬유, 의복, 신발 및 가죽제품 소매업 > 기타 의류 소매업
  "G20901", // 섬유, 의복, 신발 및 가죽제품 소매업 > 남성 의류 소매업
  "G20910", // 섬유, 의복, 신발 및 가죽제품 소매업 > 신발 소매업
  "G21602", // 사무용 기기, 안경, 사진장비 및 정밀기기 소매업 > 안경렌즈 소매업
  "G20907", // 섬유, 의복, 신발 및 가죽제품 소매업 > 액세서리/잡화 소매업
  "G20902", // 섬유, 의복, 신발 및 가죽제품 소매업 > 여성 의류 소매업
  "G20903", // 섬유, 의복, 신발 및 가죽제품 소매업 > 유아용 의류 소매업
  "G21306", // 문화, 오락 및 여가 용품 소매업 > 장난감 소매업
  "I21201", // 비알코올 음료점업 > 카페
  "G21503", // 의약품, 의료용 기구, 화장품 및 방향제 소매업 > 화장품 소매업
] as const

export type IndustryCategory = {
  code: string
  name: string
  children?: readonly IndustryCategory[]
}

export type IndustryCodeOption = Pick<IndustryCategory, "code" | "name">

export type FlatIndustryCodeOption = IndustryCodeOption & {
  categoryName: string
  subcategoryName: string
}

export type CategorizedIndustryCodeOption = IndustryCodeOption & {
  group: string
}

export type IndustryCodeOptionGroup = IndustryCodeOption & {
  children: IndustryCodeOption[]
}

export const industryCategories = [
  {
    code: "G2",
    name: "소매업",
    children: [
      {
        code: "G202",
        name: "자동차 부품 및 내장품 소매업",
        children: [
          {
            code: "G20201",
            name: "타이어 소매업",
          },
          {
            code: "G20202",
            name: "자동차 부품 소매업",
          },
        ],
      },
      {
        code: "G203",
        name: "모터사이클 및 부품 소매업",
        children: [
          {
            code: "G20301",
            name: "모터사이클 및 부품 소매업",
          },
        ],
      },
      {
        code: "G204",
        name: "종합 소매업",
        children: [
          {
            code: "G20404",
            name: "슈퍼마켓",
          },
          {
            code: "G20405",
            name: "편의점",
          },
          {
            code: "G20499",
            name: "그 외 기타 종합 소매업",
          },
        ],
      },
      {
        code: "G205",
        name: "식료품 소매업",
        children: [
          {
            code: "G20501",
            name: "곡물/곡분 소매업",
          },
          {
            code: "G20502",
            name: "가축 사료 소매업",
          },
          {
            code: "G20503",
            name: "정육점",
          },
          {
            code: "G20504",
            name: "건어물/젓갈 소매업",
          },
          {
            code: "G20505",
            name: "수산물 소매업",
          },
          {
            code: "G20506",
            name: "채소/과일 소매업",
          },
          {
            code: "G20507",
            name: "아이스크림 할인점",
          },
          {
            code: "G20508",
            name: "건강보조식품 소매업",
          },
          {
            code: "G20509",
            name: "반찬/식료품 소매업",
          },
        ],
      },
      {
        code: "G206",
        name: "음료 소매업",
        children: [
          {
            code: "G20601",
            name: "얼음 소매업",
          },
          {
            code: "G20602",
            name: "주류 소매업",
          },
          {
            code: "G20603",
            name: "생수/음료 소매업",
          },
          {
            code: "G20604",
            name: "우유 소매업",
          },
        ],
      },
      {
        code: "G207",
        name: "담배 소매업",
        children: [
          {
            code: "G20701",
            name: "담배/전자담배 소매업",
          },
        ],
      },
      {
        code: "G208",
        name: "가전제품 및 정보 통신장비 소매업",
        children: [
          {
            code: "G20801",
            name: "컴퓨터/소프트웨어 소매업",
          },
          {
            code: "G20802",
            name: "핸드폰 소매업",
          },
          {
            code: "G20803",
            name: "가전제품 소매업",
          },
        ],
      },
      {
        code: "G209",
        name: "섬유, 의복, 신발 및 가죽제품 소매업",
        children: [
          {
            code: "G20901",
            name: "남성 의류 소매업",
          },
          {
            code: "G20902",
            name: "여성 의류 소매업",
          },
          {
            code: "G20903",
            name: "유아용 의류 소매업",
          },
          {
            code: "G20904",
            name: "한복 소매업",
          },
          {
            code: "G20905",
            name: "기타 의류 소매업",
          },
          {
            code: "G20906",
            name: "침구류/커튼 소매업",
          },
          {
            code: "G20907",
            name: "액세서리/잡화 소매업",
          },
          {
            code: "G20908",
            name: "가발 소매업",
          },
          {
            code: "G20909",
            name: "실/섬유제품 소매업",
          },
          {
            code: "G20910",
            name: "신발 소매업",
          },
          {
            code: "G20911",
            name: "가방 소매업",
          },
        ],
      },
      {
        code: "G210",
        name: "철물, 공구, 창호 및 건설자재 소매업",
        children: [
          {
            code: "G21001",
            name: "철물/공구 소매업",
          },
          {
            code: "G21002",
            name: "벽지/장판/마루 소매업",
          },
          {
            code: "G21003",
            name: "건설/건축자재 소매업",
          },
          {
            code: "G21099",
            name: "기타 건설/건축자재 소매업",
          },
        ],
      },
      {
        code: "G211",
        name: "가구 소매업",
        children: [
          {
            code: "G21101",
            name: "가구 소매업",
          },
        ],
      },
      {
        code: "G212",
        name: "기타 생활용품 소매업",
        children: [
          {
            code: "G21201",
            name: "전기용품/조명장치 소매업",
          },
          {
            code: "G21202",
            name: "주방/가정용품 소매업",
          },
          {
            code: "G21203",
            name: "악기 소매업",
          },
        ],
      },
      {
        code: "G213",
        name: "문화, 오락 및 여가 용품 소매업",
        children: [
          {
            code: "G21301",
            name: "서점",
          },
          {
            code: "G21302",
            name: "문구/회화용품 소매업",
          },
          {
            code: "G21303",
            name: "음반/비디오물 소매업",
          },
          {
            code: "G21304",
            name: "운동용품 소매업",
          },
          {
            code: "G21305",
            name: "자전거 소매업",
          },
          {
            code: "G21306",
            name: "장난감 소매업",
          },
        ],
      },
      {
        code: "G214",
        name: "연료소매업",
        children: [
          {
            code: "G21401",
            name: "주유소",
          },
          {
            code: "G21402",
            name: "가스 충전소",
          },
          {
            code: "G21403",
            name: "가정용 연료 소매업",
          },
        ],
      },
      {
        code: "G215",
        name: "의약품, 의료용 기구, 화장품 및 방향제 소매업",
        children: [
          {
            code: "G21501",
            name: "약국",
          },
          {
            code: "G21502",
            name: "의료기기 소매업",
          },
          {
            code: "G21503",
            name: "화장품 소매업",
          },
        ],
      },
      {
        code: "G216",
        name: "사무용 기기, 안경, 사진장비 및 정밀기기 소매업",
        children: [
          {
            code: "G21601",
            name: "사무기기 소매업",
          },
          {
            code: "G21602",
            name: "안경렌즈 소매업",
          },
          {
            code: "G21603",
            name: "사진기/기타 광학기기 소매업",
          },
        ],
      },
      {
        code: "G217",
        name: "시계 및 귀금속 소매업",
        children: [
          {
            code: "G21701",
            name: "시계/귀금속 소매업",
          },
        ],
      },
      {
        code: "G218",
        name: "예술품, 기념품 및 장식용품 소매업",
        children: [
          {
            code: "G21801",
            name: "예술품 소매업",
          },
          {
            code: "G21802",
            name: "기념품점",
          },
        ],
      },
      {
        code: "G219",
        name: "화초 및 식물 소매업",
        children: [
          {
            code: "G21901",
            name: "꽃집",
          },
        ],
      },
      {
        code: "G220",
        name: "애완용 동물 및 관련용품 소매업",
        children: [
          {
            code: "G22001",
            name: "애완동물/애완용품 소매업",
          },
        ],
      },
      {
        code: "G221",
        name: "기타 상품 전문 소매업",
        children: [
          {
            code: "G22199",
            name: "그 외 기타 상품 전문 소매업",
          },
        ],
      },
      {
        code: "G222",
        name: "중고 상품 소매업",
        children: [
          {
            code: "G22201",
            name: "중고 상품 소매업",
          },
        ],
      },
    ],
  },
  {
    code: "I1",
    name: "숙박업",
    children: [
      {
        code: "I101",
        name: "일반 및 생활 숙박시설 운영업",
        children: [
          {
            code: "I10101",
            name: "호텔/리조트",
          },
          {
            code: "I10102",
            name: "여관/모텔",
          },
          {
            code: "I10103",
            name: "펜션",
          },
          {
            code: "I10104",
            name: "캠핑/글램핑",
          },
        ],
      },
      {
        code: "I102",
        name: "기타 숙박업",
        children: [
          {
            code: "I10201",
            name: "기숙사/고시원",
          },
          {
            code: "I10299",
            name: "그 외 기타 숙박업",
          },
        ],
      },
    ],
  },
  {
    code: "I2",
    name: "음식점업",
    children: [
      {
        code: "I201",
        name: "한식 음식점업",
        children: [
          {
            code: "I20101",
            name: "백반/한정식",
          },
          {
            code: "I20102",
            name: "국/탕/찌개류",
          },
          {
            code: "I20103",
            name: "족발/보쌈",
          },
          {
            code: "I20104",
            name: "전/부침개",
          },
          {
            code: "I20105",
            name: "국수/칼국수",
          },
          {
            code: "I20106",
            name: "냉면/밀면",
          },
          {
            code: "I20107",
            name: "돼지고기 구이/찜",
          },
          {
            code: "I20108",
            name: "소고기 구이/찜",
          },
          {
            code: "I20109",
            name: "곱창 전골/구이",
          },
          {
            code: "I20110",
            name: "닭/오리고기 구이/찜",
          },
          {
            code: "I20111",
            name: "횟집",
          },
          {
            code: "I20112",
            name: "해산물 구이/찜",
          },
          {
            code: "I20113",
            name: "복 요리 전문",
          },
          {
            code: "I20199",
            name: "기타 한식 음식점",
          },
        ],
      },
      {
        code: "I202",
        name: "중식 음식점업",
        children: [
          {
            code: "I20201",
            name: "중국집",
          },
          {
            code: "I20202",
            name: "마라탕/훠궈",
          },
        ],
      },
      {
        code: "I203",
        name: "일식 음식점업",
        children: [
          {
            code: "I20301",
            name: "일식 회/초밥",
          },
          {
            code: "I20302",
            name: "일식 카레/돈가스/덮밥",
          },
          {
            code: "I20303",
            name: "일식 면 요리",
          },
          {
            code: "I20399",
            name: "기타 일식 음식점",
          },
        ],
      },
      {
        code: "I204",
        name: "서양식 음식점업",
        children: [
          {
            code: "I20401",
            name: "경양식",
          },
          {
            code: "I20402",
            name: "파스타/스테이크",
          },
          {
            code: "I20403",
            name: "패밀리레스토랑",
          },
          {
            code: "I20499",
            name: "기타 서양식 음식점",
          },
        ],
      },
      {
        code: "I205",
        name: "동남아시아 음식점업",
        children: [
          {
            code: "I20501",
            name: "베트남식 전문",
          },
          {
            code: "I20599",
            name: "기타 동남아식 전문",
          },
        ],
      },
      {
        code: "I206",
        name: "기타 외국식 음식점업",
        children: [
          {
            code: "I20601",
            name: "분류 안된 외국식 음식점",
          },
        ],
      },
      {
        code: "I207",
        name: "구내식당 및 뷔페",
        children: [
          {
            code: "I20701",
            name: "구내식당",
          },
          {
            code: "I20702",
            name: "뷔페",
          },
        ],
      },
      {
        code: "I210",
        name: "기타 간이 음식점업",
        children: [
          {
            code: "I21001",
            name: "빵/도넛",
          },
          {
            code: "I21002",
            name: "떡/한과",
          },
          {
            code: "I21003",
            name: "피자",
          },
          {
            code: "I21004",
            name: "버거",
          },
          {
            code: "I21005",
            name: "토스트/샌드위치/샐러드",
          },
          {
            code: "I21006",
            name: "치킨",
          },
          {
            code: "I21007",
            name: "김밥/만두/분식",
          },
          {
            code: "I21008",
            name: "아이스크림/빙수",
          },
          {
            code: "I21099",
            name: "그 외 기타 간이 음식점",
          },
        ],
      },
      {
        code: "I211",
        name: "주점업",
        children: [
          {
            code: "I21101",
            name: "일반 유흥 주점",
          },
          {
            code: "I21102",
            name: "무도 유흥 주점",
          },
          {
            code: "I21103",
            name: "생맥주 전문",
          },
          {
            code: "I21104",
            name: "요리 주점",
          },
        ],
      },
      {
        code: "I212",
        name: "비알코올 음료점업",
        children: [
          {
            code: "I21201",
            name: "카페",
          },
        ],
      },
    ],
  },
  {
    code: "L1",
    name: "부동산업",
    children: [
      {
        code: "L102",
        name: "부동산관련 서비스업",
        children: [
          {
            code: "L10203",
            name: "부동산 중개/대리업",
          },
        ],
      },
    ],
  },
  {
    code: "M1",
    name: "전문, 과학 및 기술 서비스업",
    children: [
      {
        code: "M103",
        name: "법무관련 서비스업",
        children: [
          {
            code: "M10301",
            name: "변호사",
          },
          {
            code: "M10302",
            name: "변리사",
          },
          {
            code: "M10303",
            name: "법무사",
          },
          {
            code: "M10306",
            name: "행정사",
          },
          {
            code: "M10307",
            name: "공인노무사",
          },
          {
            code: "M10399",
            name: "기타 법무관련 서비스업",
          },
        ],
      },
      {
        code: "M104",
        name: "회계 및 세무관련 서비스업",
        children: [
          {
            code: "M10401",
            name: "공인회계사",
          },
          {
            code: "M10402",
            name: "세무사",
          },
          {
            code: "M10499",
            name: "기타 회계 관련 서비스업",
          },
        ],
      },
      {
        code: "M105",
        name: "광고업",
        children: [
          {
            code: "M10501",
            name: "광고 대행업",
          },
          {
            code: "M10502",
            name: "옥외/전시 광고 대행업",
          },
          {
            code: "M10503",
            name: "광고 매체 판매업",
          },
          {
            code: "M10504",
            name: "광고물 설계/제작업",
          },
          {
            code: "M10599",
            name: "기타 광고 관련 서비스업",
          },
        ],
      },
      {
        code: "M106",
        name: "시장 조사 및 여론 조사업",
        children: [
          {
            code: "M10601",
            name: "시장 조사 및 여론 조사업",
          },
        ],
      },
      {
        code: "M107",
        name: "회사 본부 및 경영 컨설팅 서비스업",
        children: [
          {
            code: "M10703",
            name: "경영 컨설팅업",
          },
        ],
      },
      {
        code: "M109",
        name: "건축 기술, 엔지니어링 및 관련 기술 서비스업",
        children: [
          {
            code: "M10901",
            name: "건축 설계 및 관련 서비스업",
          },
          {
            code: "M10902",
            name: "도시 계획 및 조경 설계 서비스업",
          },
          {
            code: "M10903",
            name: "건물 및 토목 엔지니어링 서비스업",
          },
          {
            code: "M10904",
            name: "환경 관련 엔지니어링 서비스업",
          },
          {
            code: "M10999",
            name: "기타 엔지니어링 서비스업",
          },
        ],
      },
      {
        code: "M111",
        name: "수의업",
        children: [
          {
            code: "M11101",
            name: "동물병원",
          },
        ],
      },
      {
        code: "M112",
        name: "전문 디자인업",
        children: [
          {
            code: "M11201",
            name: "인테리어 디자인업",
          },
          {
            code: "M11202",
            name: "제품 디자인업",
          },
          {
            code: "M11203",
            name: "시각 디자인업",
          },
          {
            code: "M11204",
            name: "패션/섬유/기타 전문 디자인업",
          },
        ],
      },
      {
        code: "M113",
        name: "사진 촬영 및 처리업",
        children: [
          {
            code: "M11301",
            name: "사진촬영업",
          },
        ],
      },
      {
        code: "M114",
        name: "인쇄 및 제품 제작업",
        children: [
          {
            code: "M11401",
            name: "명함/간판/광고물 제작",
          },
        ],
      },
      {
        code: "M115",
        name: "그 외 기타 전문, 과학 및 기술 서비스업",
        children: [
          {
            code: "M11502",
            name: "번역/통역 서비스업",
          },
          {
            code: "M11504",
            name: "사업/무형 재산권 중개업",
          },
        ],
      },
    ],
  },
  {
    code: "N1",
    name: "사업시설 관리, 사업 지원 및 임대 서비스업",
    children: [
      {
        code: "N101",
        name: "사업시설 유지ㆍ관리 서비스업",
        children: [
          {
            code: "N10101",
            name: "사업시설 유지·관리 서비스업",
          },
        ],
      },
      {
        code: "N102",
        name: "건물ㆍ산업설비 청소 및 방제 서비스업",
        children: [
          {
            code: "N10201",
            name: "건축물 일반 청소업",
          },
          {
            code: "N10202",
            name: "산업설비, 운송장비 및 공공장소 청소업",
          },
          {
            code: "N10203",
            name: "소독, 구충 및 방제 서비스업",
          },
        ],
      },
      {
        code: "N103",
        name: "조경관리 및 유지 서비스업",
        children: [
          {
            code: "N10301",
            name: "조경 유지·관리 서비스업",
          },
        ],
      },
      {
        code: "N104",
        name: "고용 알선 및 인력 공급업",
        children: [
          {
            code: "N10401",
            name: "고용 알선업",
          },
          {
            code: "N10402",
            name: "임시/일용 인력 공급업",
          },
          {
            code: "N10403",
            name: "상용 인력 공급 및 인사관리 서비스업",
          },
        ],
      },
      {
        code: "N105",
        name: "여행사 및 기타 여행 보조 서비스업",
        children: [
          {
            code: "N10501",
            name: "여행사",
          },
          {
            code: "N10599",
            name: "기타 여행 보조/예약 서비스업",
          },
        ],
      },
      {
        code: "N107",
        name: "사무 지원 서비스업",
        children: [
          {
            code: "N10703",
            name: "복사업",
          },
          {
            code: "N10799",
            name: "기타 사무 지원 서비스업",
          },
        ],
      },
      {
        code: "N108",
        name: "기타 사업 지원 서비스업",
        children: [
          {
            code: "N10802",
            name: "전시/컨벤션/행사 대행 서비스업",
          },
          {
            code: "N10805",
            name: "포장/충전업",
          },
        ],
      },
      {
        code: "N109",
        name: "운송장비 대여업",
        children: [
          {
            code: "N10901",
            name: "자동차 대여업",
          },
          {
            code: "N10999",
            name: "기타 운송장비 대여업",
          },
        ],
      },
      {
        code: "N110",
        name: "개인 및 가정용품 대여업",
        children: [
          {
            code: "N11001",
            name: "스포츠/레크리에이션 용품 대여업",
          },
          {
            code: "N11002",
            name: "음반/비디오물 대여업",
          },
          {
            code: "N11003",
            name: "만화방",
          },
          {
            code: "N11004",
            name: "의류 대여업",
          },
          {
            code: "N11099",
            name: "기타 개인/가정용품 대여업",
          },
        ],
      },
      {
        code: "N111",
        name: "산업용 기계 및 장비 대여업",
        children: [
          {
            code: "N11101",
            name: "건설기계/장비 대여업",
          },
          {
            code: "N11102",
            name: "컴퓨터/사무기기 대여업",
          },
          {
            code: "N11199",
            name: "기타 산업용 기계/장비 대여업",
          },
        ],
      },
    ],
  },
  {
    code: "P1",
    name: "교육 서비스업",
    children: [
      {
        code: "P105",
        name: "일반 교육기관",
        children: [
          {
            code: "P10501",
            name: "입시·교과학원",
          },
        ],
      },
      {
        code: "P106",
        name: "기타 교육기관",
        children: [
          {
            code: "P10601",
            name: "태권도/무술학원",
          },
          {
            code: "P10603",
            name: "요가/필라테스 학원",
          },
          {
            code: "P10605",
            name: "레크리에이션 교육기관",
          },
          {
            code: "P10607",
            name: "청소년 수련시설",
          },
          {
            code: "P10609",
            name: "음악학원",
          },
          {
            code: "P10611",
            name: "미술학원",
          },
          {
            code: "P10613",
            name: "기타 예술/스포츠 교육기관",
          },
          {
            code: "P10615",
            name: "외국어학원",
          },
          {
            code: "P10617",
            name: "전문자격/고시학원",
          },
          {
            code: "P10619",
            name: "사회교육시설",
          },
          {
            code: "P10621",
            name: "직원 훈련기관",
          },
          {
            code: "P10623",
            name: "운전학원",
          },
          {
            code: "P10625",
            name: "기타 기술/직업 훈련학원",
          },
          {
            code: "P10627",
            name: "컴퓨터 학원",
          },
          {
            code: "P10629",
            name: "그 외 기타 교육기관",
          },
        ],
      },
      {
        code: "P107",
        name: "교육 지원 서비스업",
        children: [
          {
            code: "P10701",
            name: "교육컨설팅업",
          },
          {
            code: "P10799",
            name: "기타 교육지원 서비스업",
          },
        ],
      },
    ],
  },
  {
    code: "Q1",
    name: "보건의료업",
    children: [
      {
        code: "Q101",
        name: "병원",
        children: [
          {
            code: "Q10101",
            name: "종합병원",
          },
          {
            code: "Q10102",
            name: "일반병원",
          },
          {
            code: "Q10103",
            name: "치과병원",
          },
          {
            code: "Q10104",
            name: "한방병원",
          },
          {
            code: "Q10105",
            name: "요양병원",
          },
        ],
      },
      {
        code: "Q102",
        name: "의원",
        children: [
          {
            code: "Q10201",
            name: "내과/소아과 의원",
          },
          {
            code: "Q10202",
            name: "외과 의원",
          },
          {
            code: "Q10203",
            name: "신경/정신과 의원",
          },
          {
            code: "Q10204",
            name: "피부/비뇨기과 의원",
          },
          {
            code: "Q10205",
            name: "안과 의원",
          },
          {
            code: "Q10206",
            name: "이비인후과 의원",
          },
          {
            code: "Q10207",
            name: "산부인과 의원",
          },
          {
            code: "Q10208",
            name: "성형외과 의원",
          },
          {
            code: "Q10209",
            name: "기타 의원",
          },
          {
            code: "Q10210",
            name: "치과의원",
          },
          {
            code: "Q10211",
            name: "한의원",
          },
          {
            code: "Q10212",
            name: "방사선 진단/병리 검사 의원",
          },
        ],
      },
      {
        code: "Q104",
        name: "기타 보건업",
        children: [
          {
            code: "Q10402",
            name: "유사 의료업",
          },
        ],
      },
    ],
  },
  {
    code: "R1",
    name: "예술, 스포츠 및 여가관련 서비스업",
    children: [
      {
        code: "R102",
        name: "도서관, 사적지 및 유사 여가관련 서비스업",
        children: [
          {
            code: "R10202",
            name: "독서실/스터디 카페",
          },
        ],
      },
      {
        code: "R103",
        name: "스포츠 서비스업",
        children: [
          {
            code: "R10306",
            name: "종합 스포츠시설",
          },
          {
            code: "R10307",
            name: "헬스장",
          },
          {
            code: "R10308",
            name: "수영장",
          },
          {
            code: "R10309",
            name: "볼링장",
          },
          {
            code: "R10310",
            name: "당구장",
          },
          {
            code: "R10311",
            name: "골프 연습장",
          },
          {
            code: "R10312",
            name: "테니스장",
          },
          {
            code: "R10313",
            name: "탁구장",
          },
          {
            code: "R10314",
            name: "기타 스포츠시설 운영업",
          },
          {
            code: "R10316",
            name: "스쿼시/라켓볼장",
          },
        ],
      },
      {
        code: "R104",
        name: "유원지 및 기타 오락관련 서비스업",
        children: [
          {
            code: "R10402",
            name: "비디오방",
          },
          {
            code: "R10404",
            name: "전자 게임장",
          },
          {
            code: "R10405",
            name: "기타 오락장",
          },
          {
            code: "R10406",
            name: "PC방",
          },
          {
            code: "R10407",
            name: "노래방",
          },
          {
            code: "R10408",
            name: "낚시터 운영업",
          },
          {
            code: "R10409",
            name: "수상/해양 레저업",
          },
          {
            code: "R10410",
            name: "복권 발행/판매업",
          },
          {
            code: "R10414",
            name: "바둑/장기/체스 경기 운영업",
          },
          {
            code: "R10499",
            name: "기타 오락관련 서비스업",
          },
        ],
      },
    ],
  },
  {
    code: "S2",
    name: "수리 및 개인 서비스업",
    children: [
      {
        code: "S201",
        name: "컴퓨터 및 주변 기기 수리업",
        children: [
          {
            code: "S20101",
            name: "컴퓨터/노트북/프린터 수리업",
          },
        ],
      },
      {
        code: "S202",
        name: "통신장비 수리업",
        children: [
          {
            code: "S20201",
            name: "핸드폰/통신장비 수리업",
          },
        ],
      },
      {
        code: "S203",
        name: "자동차 수리 및 세차업",
        children: [
          {
            code: "S20301",
            name: "자동차 정비소",
          },
          {
            code: "S20302",
            name: "자동차 세차장",
          },
        ],
      },
      {
        code: "S204",
        name: "모터사이클 수리업",
        children: [
          {
            code: "S20401",
            name: "모터사이클 수리업",
          },
        ],
      },
      {
        code: "S205",
        name: "가전제품 수리업",
        children: [
          {
            code: "S20501",
            name: "가전제품 수리업",
          },
        ],
      },
      {
        code: "S206",
        name: "기타 개인 및 가정용품 수리업",
        children: [
          {
            code: "S20601",
            name: "의류/이불 수선업",
          },
          {
            code: "S20602",
            name: "가죽/가방/신발 수선업",
          },
          {
            code: "S20603",
            name: "시계/귀금속/악기 수리업",
          },
          {
            code: "S20699",
            name: "그 외 기타 개인/가정용품 수리업",
          },
        ],
      },
      {
        code: "S207",
        name: "이용 및 미용업",
        children: [
          {
            code: "S20701",
            name: "미용실",
          },
          {
            code: "S20702",
            name: "피부 관리실",
          },
          {
            code: "S20703",
            name: "네일숍",
          },
        ],
      },
      {
        code: "S208",
        name: "욕탕, 마사지 및 기타 신체 관리 서비스업",
        children: [
          {
            code: "S20801",
            name: "목욕탕/사우나",
          },
          {
            code: "S20802",
            name: "마사지/안마",
          },
          {
            code: "S20803",
            name: "체형/비만 관리",
          },
        ],
      },
      {
        code: "S209",
        name: "세탁업",
        children: [
          {
            code: "S20901",
            name: "세탁소",
          },
          {
            code: "S20902",
            name: "셀프 빨래방",
          },
        ],
      },
      {
        code: "S210",
        name: "장례식장 및 관련 서비스업",
        children: [
          {
            code: "S21001",
            name: "장례식장",
          },
          {
            code: "S21002",
            name: "화장터/묘지/납골당",
          },
        ],
      },
      {
        code: "S211",
        name: "기타 개인서비스",
        children: [
          {
            code: "S21101",
            name: "예식장업",
          },
          {
            code: "S21105",
            name: "결혼 상담 서비스업",
          },
        ],
      },
    ],
  },
] as const

/** 중분류와 소분류 이름을 selector용 한 줄 label로 조합한다. */
export function formatIndustryName(level1Name: string, level2Name: string): string {
  return `${level1Name} > ${level2Name}`
}

/**
 * 전체 업종 트리에서 실제로 선택 가능한 소분류만 남긴다.
 *
 * 반환값은 selector의 grouped options로 바로 사용할 수 있도록 중분류를 부모로,
 * 선택 가능한 소분류를 children으로 둔다. 선택 가능한 소분류가 없는 중분류는 제외한다.
 */
export function getGroupedIndustryOptions(
  categories: readonly IndustryCategory[] = industryCategories,
  availableCodes: readonly string[] = rtIndustryCode
): IndustryCodeOptionGroup[] {
  const availableCodeSet = new Set(availableCodes)
  const groups: IndustryCodeOptionGroup[] = []

  for (const topLevelCategory of categories) {
    for (const level1Category of topLevelCategory.children ?? []) {
      const children = (level1Category.children ?? [])
        .filter((level2Category) => availableCodeSet.has(level2Category.code))
        .map(({ code, name }) => ({ code, name }))

      if (children.length > 0) {
        groups.push({
          code: level1Category.code,
          name: level1Category.name,
          children,
        })
      }
    }
  }

  return groups.sort((a, b) => a.name.localeCompare(b.name))
}

/**
 * Selector에서 모든 옵션을 `중분류 > 소분류`로 평탄화하여 표시한다.
 */
export function getFlatIndustryOptions(
  categories: readonly IndustryCategory[] = industryCategories,
  availableCodes: readonly string[] = rtIndustryCode
): FlatIndustryCodeOption[] {
  return getGroupedIndustryOptions(categories, availableCodes).flatMap(
    (level1Category) =>
      level1Category.children
        .map((level2Category) => ({
          code: level2Category.code,
          name: formatIndustryName(level1Category.name, level2Category.name),
          categoryName: level1Category.name,
          subcategoryName: level2Category.name,
        }))
        .sort((a, b) => a.code.localeCompare(b.code)) // 동일 카테고리 내에서는 code 기준으로 정렬. 단순 오름차순 정렬 시 '기타'가 앞으로 오는 문제가 있다.
  )
}

/**
 *  Selector에서 group 단위로 카테고리를 나누어 표시하는 데에 사용된다.
 *
 *  중분류
 *  - 소분류 1
 *  - 소분류 2
 */
export function getCategorizedFlatIndustryOptions(
  rtIndustryCodeOnly = false
): CategorizedIndustryCodeOption[] {
  const categories = industryCategories ?? []
  const availableCodes = rtIndustryCodeOnly
    ? rtIndustryCode
    : categories.flatMap((category) =>
        (category.children ?? []).flatMap((subcategory) =>
          (subcategory.children ?? []).map(({ code }) => code)
        )
      )
  return getGroupedIndustryOptions(categories, availableCodes).flatMap(
    (level1Category) =>
      level1Category.children
        .map((level2Category) => ({
          code: level2Category.code,
          name: level2Category.name,
          group: level1Category.name,
        }))
        .sort((a, b) => a.code.localeCompare(b.code)) // 동일 카테고리 내에서는 code 기준으로 정렬. 단순 오름차순 정렬 시 '기타'가 앞으로 오는 문제가 있다.
  )
}

angular.module("uCountitUiApp").factory("IndustryCode", () => ({
  getGroupedOptions: getGroupedIndustryOptions,
  getFlatOptions: getFlatIndustryOptions,
  getCategorizedFlatOptions: getCategorizedFlatIndustryOptions,
  formatName: formatIndustryName,
}))
